import { get, post } from "../http-client/client";
import { ApiResponse } from "../http-client/Response";

export interface TrialUserSummary {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  status: string;
}

export interface TrialSummary {
  organizationId: string;
  organizationName: string;
  trialEndsAt: string | null;
  daysRemaining: number;
  isExpired: boolean;
  tokenLimit: number | null;
  tokensConsumed: number;
  percentUsed: number;
  isOverLimit: boolean;
  primaryUser: TrialUserSummary | null;
}

export interface TrialUser {
  userId: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  company: string | null;
  jobTitle: string | null;
  teamSize: string | null;
  legalHoursPerWeek: number | null;
  meetingAssistantEnabled: boolean;
  signedUpAt: string | null;
  status: string;
  organizationId: string;
  organizationName: string;
  trialEndsAt: string | null;
  daysRemaining: number;
  isExpired: boolean;
  tokenLimit: number | null;
  tokensConsumed: number;
  percentUsed: number;
  isOverLimit: boolean;
}

export const listTrialUsers = (): Promise<ApiResponse<TrialUser[]>> => {
  return get(`/admin/trials/users`, null);
};

export const extendTrial = (
  organizationId: string,
  days?: number,
): Promise<ApiResponse<TrialSummary>> => {
  return post(`/admin/trials/${organizationId}/extend`, days ? { days } : {});
};
